import { useEffect, useState } from 'react'
import { featureFlags } from '../config/featureFlags'
import { API_ENDPOINTS } from '../config/api'
import { getActiveOrgId } from '../utils/orgUtils'

function getAuthHeaders(): HeadersInit {
  const token =
    typeof window !== 'undefined'
      ? localStorage.getItem('token') || localStorage.getItem('accessToken')
      : null
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export type VisibilitySummary = {
  restrictedMode: boolean
  collaborativeMode: boolean
  allowedStandards: string[]
}

export function useRestrictedVisibility() {
  const [summary, setSummary] = useState<VisibilitySummary | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!featureFlags.STANDARD_SCOPE_VISIBILITY_V1) {
      setSummary(null)
      return
    }
    const orgId = getActiveOrgId()
    if (!orgId) return
    setLoading(true)
    void fetch(API_ENDPOINTS.STANDARDS_VISIBILITY_SUMMARY(orgId), { headers: getAuthHeaders() })
      .then((r) => r.json())
      .then((body) => setSummary(body?.data || body || null))
      .catch(() => setSummary(null))
      .finally(() => setLoading(false))
  }, [])

  return {
    loading,
    restrictedMode: Boolean(summary?.restrictedMode),
    allowedStandards: summary?.allowedStandards || [],
    summary,
  }
}
